var map = {
	"./black/quantijingyin2.png": "kE7Y",
	"./blue/quantijingyin2.png": "htjS",
	"./white/quantijingyin2.png": "+wxN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yA+Y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/quantijingyin2\.png$
// module id = yA+Y
// module chunks = 24